import { HoverCard as MantineHoverCard } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./hover-card.module.scss";
import type { CustomHoverCardFactory, IProps } from "./hover-card.types";
import { Container, Header, Title, Item, List, Content, Info, Subtitle, Dropdown } from "./hover-card-components";

/**
 * HoverCard wrapper that standardizes dropdown styling and behavior.
 */
const HoverCard = componentWrapper<CustomHoverCardFactory, IProps>("HoverCard", (props, _ref) => (
    <MantineHoverCard
        classNames={{ dropdown: styles["dropdown"] }}
        closeDelay={0}
        transitionProps={{ duration: 0 }}
        {...props}
    />
));

HoverCard.Target = MantineHoverCard.Target;
HoverCard.Dropdown = Dropdown;
HoverCard.Container = Container;
HoverCard.Header = Header;
HoverCard.Title = Title;
HoverCard.Subtitle = Subtitle;
HoverCard.Item = Item;
HoverCard.List = List;
HoverCard.Content = Content;
HoverCard.Info = Info;

export { HoverCard };
